import { render, staticRenderFns } from "./MetaFlexible.vue?vue&type=template&id=f2329a5e&scoped=true&"
import script from "./MetaFlexible.vue?vue&type=script&lang=ts&"
export * from "./MetaFlexible.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2329a5e",
  null
  
)

export default component.exports